import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import Text from 'tio-ui/components/text';
import { PhCheck, PhX } from 'ember-phosphor-icons';

interface AppPageProsVsConsSignature {
  Args: {
    cons?: string[];
    pros?: string[];
  };
}

const AppPageProsVsConsComponent: TOC<AppPageProsVsConsSignature> = <template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div>
      <Text @weight="semibold" class="tio-fg-success mb-3 block">
        {{t "plan_details.pros"}}
      </Text>
      <ul class="space-y-2">
        {{#each @pros as |pro|}}
          <li class="tio-row-top-tight">
            <PhCheck class="tio-icon-sm tio-fg-success shrink-0 mt-1" />
            <Text @variant="muted" @size="sm">{{t pro htmlSafe=true}}</Text>
          </li>
        {{/each}}
      </ul>
    </div>
    <div>
      <Text @weight="semibold" class="tio-fg-danger mb-3 block">
        {{t "plan_details.cons"}}
      </Text>
      <ul class="space-y-2">
        {{#each @cons as |con|}}
          <li class="tio-row-top-tight">
            <PhX class="tio-icon-sm tio-fg-danger shrink-0 mt-1" />
            <Text @variant="muted" @size="sm">{{t con htmlSafe=true}}</Text>
          </li>
        {{/each}}
      </ul>
    </div>
  </div>
</template>;

export default AppPageProsVsConsComponent;
